<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <!-- <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-flex"
      style="gap: 8px;"
    >
      <Logo
        size="44"
        :is-black="$store.state.appConfig.layout.skin !== 'dark'"
        :is-white="$store.state.appConfig.layout.skin === 'dark'"
      />
      <h5 class="p-0 m-0">
        {{ getBrandName() }}
      </h5>
    </div> -->

    <b-navbar-nav class="nav align-items-center ml-auto">

      <div
        v-if="isLogin"
        class="mx-2 accountId"
      >
        <span>{{ $t('accountId',{brand_name:getBrandName()}) }}</span>
        <span>:</span>
        <span>{{ isLogin }}</span>
      </div>
      <dark-Toggler class=" d-block" />
      <MessagesNav />
      <locale />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import { mapActions } from 'vuex'
import useAppConfig from '@core/app-config/useAppConfig'
import AuthApis from '@/services/apis/auth'
import ToastificationMessageContent from './ToastificationMessageContent.vue'
import Locale from './Locale.vue'
import MessagesNav from './Messaging.vue'

let client
const auth = new AuthApis()
export default {
  components: {
    BLink,
    BNavbarNav,

    Locale,
    DarkToggler,
    MessagesNav,
    Logo: () => import(`@/views/${process.env.VUE_APP_THEME_NAME}/components/logo.vue`),
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      profileLink: '',
      sseClient: null,
    }
  },

  computed: {
    fullName() {
      return `${this.$store.state.auth.user.first_name
        ? this.$store.state.auth.user.first_name
        : ''} 
      ${this.$store.state.auth.user.last_name
    ? this.$store.state.auth.user.last_name
    : ''}`
    },
    isLogin() {
      return this.$store.state.auth.user.id
    },
  },
  watch: {
    isLogin(val) {
      if (val) {
        this.sseClient.polyfillOptions.headers.authorization = localStorage.getItem('token')
        this.sseClient.connect()
      } else {
        this.sseClient.polyfillOptions.headers.authorization = null
        this.sseClient.disconnect()
      }
    },
  },

  async created() {
    this.profileLink = this.$i18n.locale
  },

  async mounted() {
    await this.disconnect()

    client = this.$sse.create()
    client.on('message', this.handleMessaging)
    this.sseClient = client

    if (this.isLogin) {
      this.sseClient.polyfillOptions.headers.authorization = localStorage.getItem('token')
      this.sseClient.connect()
    }
  },

  methods: {
    ...mapActions(['logout']),
    ...mapActions('Messaging', ['openMessageModal', 'setUnreadMessages', 'setEvent']),
    async submitLogout() {
      const response = await this.logout(this.form)
      if (response.status === 200) {
        this.$router.push(`/${this.$i18n.locale}/login?redirect=${this.$route.path}`)
      }
    },

    handleMessaging(message) {
      if (message) {
        const messageObject = JSON.parse(message)

        if (messageObject.event) this.setEvent(messageObject.event)

        this.$toast({
          component: ToastificationMessageContent,
          props: {
            ...messageObject,
            toastMessageOnClick: id => { this.openMessageModal(id) },
          },
        },
        {
          position: 'bottom-right',
          transition: 'Vue-Toastification__bounce',
        })
        // TODO : can get all messages when user stay in message page but not good idea
        // if (this.$route.name === 'messages') this.setAllMessages()
        this.setUnreadMessages()
        auth.steps()
      }
    },

    disconnect() {
      if (client) {
        client.disconnect()
        client = null
      }
    },
  },

  async beforeUnmount() {
    await this.disconnect()
  },
  setup() {
    const { skin } = useAppConfig()
    const darkLight = localStorage.getItem('vuexy-skin')
    if (darkLight) {
      skin.value = darkLight
    }
  },
}
</script>

<style scoped>
@media screen and (max-width:460px) {
  .bookmark-wrapper{
    justify-content: center;
    margin:unset;
  }

  .accountId{
    flex-basis: 100%;
  }
}
@media screen and (min-width:460px) and (max-width:1200px){
  .bookmark-wrapper{
    margin: 0 2rem;
  }
}
@media screen and (max-width:800px){
  .powered_by_cryptoforce{
    display: none !important;
  }
}
@media screen and (max-width:768px){
  .accountId{
    display: none;
  }
}
</style>
